const Pencil = ({
  color = '#E9BF6E',
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5781 4.92188L19.5781 9.92188" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
      <path
        d="M8.25 21.2501L2.25 22.2501L3.25 16.2501L16.664 2.83606C17.0391 2.46112 17.5477 2.25049 18.078 2.25049C18.6083 2.25049 19.1169 2.46112 19.492 2.83606L21.664 5.00806C22.0389 5.38312 22.2496 5.89173 22.2496 6.42206C22.2496 6.95239 22.0389 7.46101 21.664 7.83606L8.25 21.2501Z"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default Pencil;
